module.exports = __webpack_public_path__ + "img/1.06.thmb.0314dedc.jpg";